import React, { useState } from 'react';
import {
  GetFishingWater_fishingWater_country,
  WaterTypes,
  GetFishingWater_fishingWater_region,
  GetFishingWaterTopSpecies_fishingWater_topSpeciesSummary,
} from '../../../../interfaces/graphql';
import { useAnalytics } from '../../../../contexts/AnalyticsContext/AnalyticsContext';
import { trackEvent } from '../../../../helpers/analytics/trackEvent';
import { AppDownloadModal } from '../../../../components/AppDownloadModal/AppDownloadModal';
import { getFAQData } from './helpers/getFAQData';
import { PostExtended } from '../../../../components/FishingReportsGrid/components/FishingReportCard';
import { FAQ } from '../../../../components/FAQ/FAQ';

interface IProps {
  country: GetFishingWater_fishingWater_country | null;
  descriptionOfWaterType: WaterTypes;
  fishingWaterName: string;
  fishingWaterId: string;
  latitude: number;
  longitude: number;
  region: GetFishingWater_fishingWater_region | null;
  recentCatchPostList: PostExtended[];
  topSpeciesSummary?: GetFishingWaterTopSpecies_fishingWater_topSpeciesSummary;
}

export const FAQSection = ({
  country,
  descriptionOfWaterType,
  fishingWaterName,
  fishingWaterId,
  latitude,
  longitude,
  region,
  recentCatchPostList,
  topSpeciesSummary,
}: IProps) => {
  const [isAppDownloadModalOpen, setIsAppDownloadModalOpen] = useState(false);
  const { currentPage } = useAnalytics();

  const handleCTAClick = (): void => {
    void trackEvent({
      name: 'mykiss_cta_button_clicked',
      properties: {
        source: 'FAQSection',
        source_id: fishingWaterId,
        type: 'downloadModal',
        page: currentPage,
      },
    });
    setIsAppDownloadModalOpen(true);
  };

  const faqData = getFAQData({
    country,
    descriptionOfWaterType,
    fishingWaterName,
    handleCTAClick,
    latitude,
    longitude,
    region,
    recentCatchPostList,
    topSpeciesSummary,
  });

  return (
    <FAQ
      className="mb-fw"
      faqData={faqData}
      headingVariant="sm"
      showFAQMetaData
      showMoreFAQ={false}
      title={`FAQ about ${fishingWaterName} fishing`}
    >
      <AppDownloadModal
        appDownloadSourceId={fishingWaterId}
        appDownloadSource="FAQSection"
        isModalOpen={isAppDownloadModalOpen}
        onCloseModal={() => setIsAppDownloadModalOpen(false)}
      />
    </FAQ>
  );
};
